import React, {Component} from 'react';
import {connect} from 'react-redux';
import {RootState, selectors} from '../store';
import {
  IonPopover,
  IonIcon,
  IonSelect,
  IonSelectOption,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonMenuButton,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonDatetime,
  IonTitle,
  IonBackButton,
  IonInput,
  IonRow,
  IonCol,
  IonPage,
  IonFooter,
  IonText,
  IonSegment,
  IonCard,
  IonSegmentButton,
  IonAlert,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCardContent, IonItemSliding, IonItemOptions, IonItemOption
} from '@ionic/react';
import './Articlelist.css';
import AboutPopover from '../components/AboutPopover';
import {calendar, pin, addCircleOutline, contact, contacts, journal} from 'ionicons/icons';
import {RouteComponentProps} from "react-router";
import {AuthComponent} from "./_/AuthComponent";
import {StaticEvent} from "../_/StaticEvent";
import {ApiService} from "../_/ApiService";
import {Static} from "../_/Static";
import _ from "../_";

type Props = RouteComponentProps<{}> & ReturnType<typeof mapStateToProps>

type State = {
  showPopover: boolean,
  showPopoverEvent: null | MouseEvent,

  _userData: any,
  pageData: any,

}

class Articlelist extends AuthComponent<Props, State> {
  static RoutePathname = /^\/articlelist/gi;

  constructor(props: Props) {
    super(props);

    this.state = {
      showPopover: false,
      showPopoverEvent: null,

      _userData: null,
      pageData: null,
    };
  }

  async componentDidMount() {
    await super.componentDidMount();

    //必須要引用 AuthComponent, 才能在這裡拿取用戶資料
    //若是引用 BaseComponent 則不需要下面
    // @ts-ignore
    this.setState({
      _userData: this._userData,
    });
  }

  async afterEventsLoader() {
    window.setTimeout(() => {
      const myPathname = this.props.location.pathname;
      if (myPathname.match(Articlelist.RoutePathname)) {
        if (this._doLoadingPageDataInDidMount) {
          this._doLoadingPageDataInDidMount = false;
          this._loadPageData();
        } else {
          return;
        }
      }
    }, 1);
  }

  async _loadPageData() {
    // VALIDATE INPUT
    // @ts-ignore
    // const cate = this.props.match.params.cate;
    // if (!cate) {
    //   return; //ERROR INPUTS
    // }

    // WAITING SCREEN
    StaticEvent.LoadingEvent.next(true);

    // POST
    let postData = {
      cate: 12,
      timezoneOffset: (new Date()).getTimezoneOffset() * 60 * 1000,
    };
    const postUrl = ApiService.urlMapping('~/api/1/articlelist');
    Static.apiService
      .post(postUrl, postData)
      .subscribe(async (res: any) => {
          // CLOSE WAITING SCREEN
          StaticEvent.LoadingEvent.next(false);

          let data = res.data;
          _.debugManager.log(data);

          let error = data.error || null;
          let result = error == null;

          if (result) { // SUCEESS

            let payload = data.payload;
            _.debugManager.log(payload);

            // @ts-ignore
            await this.setState({
              pageData: payload,
            });

          } else {
            // AUTH USER EXPIRED
            if (error.code == 2) {
              alert('帳號被登出，請重新登入');
              window.location.href = '/login';
              //this.props.history.push('/login')
              return;
            }

            alert(error.message);
          }
        }, async (err) => {
          // CLOSE WAITING SCREEN
          StaticEvent.LoadingEvent.next(false);
          _.debugManager.warn(err);
          alert('網路連線有問題');
        }
      );
  }


  presentPopover = (e: MouseEvent) => {
    this.setState(() => ({
      showPopover: true,
      showPopoverEvent: e
    }));
  };

  dismissPopover = () => {
    this.setState(() => ({
      'showPopover': false,
      'showPopoverEvent': null
    }));
  };

  render() {
    let Items: any = null;
    let pageData = _.utilManager.existGet(this.state, 'pageData');

    if (pageData != null) {
      let its = pageData.List_文章;


      if (its.length > 0) {
        Items = <>
          <IonList lines="full" className="stulist">
            {its.map(it => {

                const re = /\s*(?:,|$)\s*/;
                const coverList = [...(it.封面組 + (",")).split(re), ""];

                return <IonCard key={it.文章Id} button
                                href={`/articlecontent/${it.文章Id}`} onClick={
                  (e) => {
                    e.preventDefault();
                    this.props.history.push(`/articlecontent/${it.文章Id}`);
                  }}>
                  <img src={ApiService.urlImageMapping("~/" + coverList[0])}/>
                  <IonCardHeader>
                    <IonCardSubtitle><span>{it.__文章類別名稱}</span><span>{it.作者}</span></IonCardSubtitle>
                    <IonCardTitle>{it.標題}</IonCardTitle>
                  </IonCardHeader>
                </IonCard>
              }
            )}

          </IonList>
        </>;
      } else {
        Items = <>
          No Data
        </>;
      }
    }

    return (
      <>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonBackButton defaultHref="/" onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.props.history.goBack();
              }} text="返回"/>
            </IonButtons>
            <IonTitle>全球見證</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonPopover
          isOpen={this.state.showPopover}
          event={this.state.showPopoverEvent}
          onDidDismiss={this.dismissPopover}
        >
          <AboutPopover
            dismissPopover={this.dismissPopover}
          />
        </IonPopover>

        <IonContent color="light" className="atlist-page">
          {Items}
        </IonContent>
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  conferenceDate: selectors.sessions.conferenceStart(state.sessions),
  isAuthenticated: state.user.isAuthenticated

});

export default connect(
  mapStateToProps
)(Articlelist);
